import { useState } from 'react';
import { createUser } from '../../services/users/createUserService.js';
import { isValidName, isValidUsername, isEmailValid, isPasswordValid, isDescriptionValid } from '../../utils/validations/userValidations.js';

const initialForm = {
    companyid: '', // opcional
    name: '',
    lastname: '',
    username: '',
    email: '',
    password: '',
    description: ''
};

export const useCreateUser = () => {
    const [form, setForm] = useState(initialForm);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [validationErrors, setValidationErrors] = useState([]);
    const clearError = () => setError('');
    const clearSuccess = () => setSuccess('');
    const clearValidationErrors = () => setValidationErrors([]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const resetForm = () => {
        setForm(initialForm);
        setError('');
        setSuccess('');
        setValidationErrors([]);
    };

    const submit = async () => {
        // LIMPIEZA GLOBAL
        setError('');
        setSuccess('');
        setValidationErrors([]);

        const { companyid, name, lastname, username, email, password, description } = form;
        
        // Validaciones frontend
        if (!isValidName(name) || !isValidName(lastname)){
            setError('Los campos de nombre y apellidos, solo pueden contener letras, sin caracteres especiales.');
            return;
        }
        if (!isValidUsername(username)){
            setError('El nombre de usuario solo pueden contener letras y números.');
            return;
        }
        if (!isEmailValid(email)){
            setError('El correo electrónico no es válido.');
            return;
        }
        if (!isPasswordValid(password)){
            setError('La contraseña debe tener al menos 7 caracteres.');
            return;
        }
        if (!isDescriptionValid(description)){
            setError('El campo comentarios no puede contener caracteres especiales.');
            return;
        }

        // Payload limpio
        const payload = {
            companyid: companyid ? Number(companyid) : undefined,
            name,
            lastname,
            username,
            email,
            password,
            description
        };
        
        // Si todo esta validado, procedimiento guardar
        try {
            await createUser(payload);
            setSuccess('El usuario ha sido creado exitosamente.');
        } catch (err) {
            // Validación del archivo: middleware/validator.js del backend
            if (err.response?.status === 400 && Array.isArray(err.response.data?.errors)) {
                setValidationErrors(err.response.data.errors);
                return;
            }
            // Error general
            setError(
                err.response?.data?.error || 
                err.response?.data?.message || 
                'Error creando usuario.'
            );
        }
    }

    return {
        form,
        error,
        success,
        validationErrors,
        handleChange,
        submit,
        resetForm,
        clearError,
        clearSuccess,
        clearValidationErrors
    };
}
